import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { WarehouseReceiptProductCreateRequest } from './warehouse-receipt-product-create.request';
import { WarehouseFileRequest } from './warehouse-file.request';
import { Nillable } from '@web/utils';
import { dateWithOffsetSerializer } from '@web/common';

@jsonObject
export class WarehouseReceiptCreateRequest {
  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public readonly receiptedAt!: Date;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonArrayMember(WarehouseReceiptProductCreateRequest)
  public readonly goods!: WarehouseReceiptProductCreateRequest[];

  @jsonArrayMember(WarehouseFileRequest)
  public readonly files?: Nillable<WarehouseFileRequest[]>;

  public constructor(
    receiptedAt: Date,
    goods: WarehouseReceiptProductCreateRequest[],
    files?: Nillable<WarehouseFileRequest[]>,
    comment?: Nillable<string>,
  ) {
    this.receiptedAt = receiptedAt;
    this.goods = goods;
    this.files = files;
    this.comment = comment;
  }
}
